enum ElementNames {
    DESCRIPTION = 'Description',
    TITLE = 'Title'
}

export default ElementNames;
